/** SPEC §20: baselines en speling in de web-app. */
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { baselineVerschil, speling, werkpakketPlanning, type BaselineData } from '@ep/core';
import { api } from '../lib/api';
import { useMag, type Data } from '../lib/data';

export interface BaselineRij { id: string; naam: string; door: string; aangemaakt: string; data: BaselineData }

export function useBaselines(projectId?: string) {
  const mag = useMag();
  return useQuery({ queryKey: ['baselines', projectId], queryFn: () => api.get<BaselineRij[]>(`/api/projecten/${projectId}/baselines`), enabled: !!projectId && mag('projecten.lezen') });
}

/** Planning per werkpakket nu, speling en verschil met de gekozen baseline. */
export function useProjectStand(d: Data | undefined, projectId: string | undefined, baseline?: BaselineRij | null) {
  return useMemo(() => {
    if (!d || !projectId) return null;
    const wps = d.werkpakketten.filter((w) => w.projectId === projectId).sort((a, b) => a.volgorde - b.volgorde);
    const tps = d.takenpakketten.filter((t) => t.projectId === projectId);
    const taken = d.taken.filter((t) => t.projectId === projectId && t.status === 'GEPLAND');
    const nu = werkpakketPlanning(wps, tps, taken);
    const sp = speling(nu);
    const p = d.projecten.find((x) => x.id === projectId);
    const buffer = sp.einde && p?.livegang ? baselineVerschil(sp.einde, p.livegang) : null;
    const perWp = new Map(nu.map((w) => {
      const b = baseline?.data.werkpakketten.find((x) => x.id === w.id);
      return [w.id, { ...w, speling: sp.perId.get(w.id) ?? null, baseline: b ?? null, verschil: baselineVerschil(b?.eind, w.eind) }];
    }));
    return { perWp, einde: sp.einde, buffer, verschil: baselineVerschil(baseline?.data.einde, sp.einde) };
  }, [d, projectId, baseline]);
}

export const verschilTekst = (n: number | null) => (n == null ? '' : n === 0 ? 'gelijk' : `${n > 0 ? '+' : '−'}${Math.abs(n)} wd`);
